import { CompositeButton, useCallStateHooks, WithTooltip } from '@stream-io/video-react-sdk';
import { ScreenShare, ScreenShareOff } from 'lucide-react';

export const ScreenShareButton = () => {
  const { useScreenShareState } = useCallStateHooks();
  const { screenShare } = useScreenShareState();

  return (
    <CompositeButton
      active={screenShare.enabled}
      variant="secondary"
      onClick={() => screenShare.toggle()}
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <WithTooltip
          title={screenShare.enabled ? 'Stop Sharing' : 'Share Screen'}
          style={{
            marginTop: '-6px',
          }}
        >
          <div className="mt-2">
            {screenShare.enabled ? (
              <ScreenShareOff className="w-5 h-5" />
            ) : (
              <ScreenShare className="w-5 h-5" />
            )}
          </div>
        </WithTooltip>
      </div>
    </CompositeButton>
  );
};
